<template>
  <div id="tokens" v-if="showWindow">    
    <vs-popup classContent="popup-example" title="Table setup" :active.sync="popUps.popupShowActive">
        <div class="vx-row mb-4">
            <div class="vx-col w-1/4" v-for="(column,index) in params" :key="index" style="padding: 5px">
                <vs-button class="ml-auto w-full" color="primary" :type="getType(index)" @click="showHideColumn(index)">{{index}}</vs-button> 
            </div>
        </div>
    </vs-popup>    
    <div class="flex flex-wrap justify-between items-center">
      <vs-button color="primary" class="inline-block" type="flat" @click="popUps.popupShowActive=true">Fields settings</vs-button>
      <draggable v-model="fieldsData" @start="drag=true" @end="saveSort()" class="vx-row mb-4" >
          <div class="vx-row mb-4" v-for="(item) in fieldsData" :key="item.order" v-show="item.show && item.name!=='timestamp'">
              <div class="vx-col w-full">
                {{item.name}} <vs-button radius color="primary" class="inline-block" type="flat"  icon="content_copy" @click="copyToClipBoard(item.name)"></vs-button>
                <br />
                <vs-input class="inputx inline-block" size="normal" v-model="params[item.name]"/>&nbsp;
              </div>
          </div>      
        </draggable>
    </div>    
  </div>
</template>

<script>
import axios from "@/axios.js"
import draggable from 'vuedraggable'
export default {
    data() {
        return {
           params:{amount:0},
           fieldsData:[],
           dataOrder: [],
           popUps:{
            popupShowActive:false,
            popupActive:false,
            popupDeclineActive: false,
            popupApproveOrder: false,
            popupUpdateRefActive: false,
            popupCaptureActive: false,
            popupSellActive:false,
            popupSellManualActive: false,
            popupCompleteDeposit: false,
            popupCancelOrder: false,
           },
           buttons:{
             sellComplete: false,
             sellCompleteManual: false,
             completeDeposit: false,
             cancelOrder: false,
             completeManual: false
           }
        }
    },
    components: {
      draggable,
  },
    computed:{
      amount:{
        get: function(){
          if(this.params.amount!==undefined)
            return this.formatNumber(this.params.amount);
          return false;
        },
        set: function(num){
          this.params.amount=num;
        }
      },
      showWindow(){
        if(this.$route.path.indexOf('/tokens/')!==-1){
          //if(this.fieldsData.length===0)
            this.setData();
          return true;
        }
        return false;
      },
    },
    methods: {
      showHideColumn: function(name){
          for(let i in this.dataOrder){
              if(this.dataOrder[i].name===name){
                this.dataOrder[i].show = !this.dataOrder[i].show;                
                for(let j in this.fieldsData){
                  if(this.fieldsData[j].name===this.dataOrder[i].name){
                    this.fieldsData[j].show = this.dataOrder[i].show;
                  }
                }
                break;
              }
          }
          localStorage.setItem('tokenDetails', JSON.stringify(this.fieldsData));
      },
      getType: function(name){
          for(let i in this.dataOrder){
              if(this.dataOrder[i].name===name){
                return this.dataOrder[i].show ? 'filled' : 'border';
              }
          }
          return 'filled';
      },
      saveSort: function(){
        this.drag=false;
        let counter = 1;
          for(let i in this.fieldsData){
            this.fieldsData[i].order = counter;
            counter++;
          }
          localStorage.setItem('tokenDetails', JSON.stringify(this.fieldsData));
      },
      loadState: function(){
          this.dataOrder = JSON.parse(localStorage.getItem('tokenDetails'));
      },
      formatNumber: function(num) {
        num = num.toString().split(',').join('');
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      },
      copyToClipBoard: function(index){
        let that = this;
        let text = this.params[index];
        let textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        if(document.execCommand('copy'))
              that.openAlert('success','','copied to clipboard');
        document.body.removeChild(textArea);
      },
      isReadOnly: function(index){
        return this.editable.indexOf(index)===-1;
      },
      setData: function(){
        this.loadState();
        const params = new URLSearchParams();
        params.append('tokenId', this.$route.params.tokenId);
        let that = this;
        axios.post("/api/tokens",params)
        .then((response) => {
          that.params = response.data;          
          let data = response.data;
          let counter = 1;          
          if(that.dataOrder!==null && that.dataOrder.length>0){
            for(let i in response.data){
              let order = that.dataOrder.length + counter;
              let show  = true;
              for(let j in that.dataOrder){
                if(that.dataOrder[j].name===i){
                  order = that.dataOrder[j].order;
                  if(!that.dataOrder[j].show)
                    show = that.dataOrder[j].show;
                  break;
                }
              }                              
              that.fieldsData.push({"name":i,"value":response.data[i],"order":order,"show":show})
              counter++;
            }
          } else{
            for(let i in response.data){
              that.fieldsData.push({"name":i,"value":response.data[i],"order":counter,"show":true})
              counter++;
            }
          }
          that.fieldsData.sort(function(a, b) {
            var x = a.order, y = b.order;
            // Compare the 2 dates
            if (x < y) return -1;
            if (x > y) return 1;
            return 0;
          });
          if(data.status === 'approved'){
            that.$set(that.params,'value_out',response.data.value_approved.replace(' BTC',''));
            that.params.amount = 0;
          }
          if (data.status !== 'processed' && data.status !== 'approved') {
              that.buttons.cancelOrder = true;
                if (data.type === 'buy') {
                    that.buttons.buyButtons = true;
                    if(data.status=='pending approval'){
                        that.buttons.allowCapture = true;
                    }
                } else if (data.type === 'sell') {
                    if(data.status==='pending approval'){   
                        that.buttons.sellComplete = true;
                    } else if(data.status==='unprocessed'){
                        that.buttons.sellCompleteManual = true;
                    }
                }
            } else if (data.type === 'buy' && data.status === 'approved') {
                that.buttons.completeManual = true;
            }
        })
        .catch(() => {  })
      },
      reset: function(){
        this.popUps={
          popupShowActive: false,
          popupActive:false,
          popupSellActive:false,
          popupSellManualActive: false,
          popupCompleteDeposit: false,
          popupCancelOrder: false,
        }
        this.buttons={
          sellComplete: false,
          sellCompleteManual: false,
          completeDeposit: false,
          cancelOrder: false
        }
      },
      sendData: function(type){
        let that = this;
        const params = new URLSearchParams();
        params.append('type', type);
        switch(type){
          case 'complete-deposit':
              params.append('email', this.params.username);
              params.append('wallet', this.params.wallet);
              params.append('wire_ref', this.params.reference);
              params.append('amount', (this.params.amount).replace(',',''));
              break;
          case 'cancel-order':
              params.append('email', this.params.username);
              params.append('reference1', this.params.reference);
              break;
          case 'decline':
          case 'capture':
              params.append('email', this.params.username);
              params.append('wire_ref', this.params.reference);
              break;
            case 'approve':
              params.append('amount', (this.params.amount).replace(',',''));
              params.append('email', this.params.username);
              params.append('wire_ref', this.params.reference);
              break; 
            case 'wire-ref-update':
              params.append('transaction_id', this.params.transaction_id);
              params.append('email', this.params.username);
              params.append('trans_ref', this.params.psp_reference);
              break;
            case 'complete-manual':
              params.append('wire_ref', this.params.reference);
              params.append('commission', this.params.commission);
              params.append('amount', (this.params.amount).replace(',',''));
              params.append('value_out', this.params.value_out);
              params.append('ext_ref', this.params.ext_ref);
              params.append('send_code', this.params.send_code);
              break;
        }
        this.$vs.loading();
        axios.post("/api/transaction",params)
        .then((data) => {          
          that.$vs.loading.close();
          if(data.data[0].out1==='done!'){
            that.popupActive = false;
            that.params = {amount: 0};
            that.openAlert('success','Success',data.data[0].out1);
            that.reset();
            that.setData(true);
          } else{
            that.openAlert('danger','Failed',data.data[0].out1);
          }
        })
        .catch((error) => { that.$vs.loading.close(); that.openAlert('danger','Failed',error.data[0].out1); })
      },
      openAlert(color,title,text) {
      let colorAlert = color;
      this.$vs.notify({
          title: title,
          text: text,
          color: colorAlert
      })
    },
    }
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
